"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameWinner = void 0;
var rules_1 = require("../rules");
/**
 * @internal
 * Determines the winner (if any) of a game.
 * @param game The game that has played
 * @param rules The rules to determine who has won
 * @returns
 * - `home` when the home player has won
 * - `away` when the away player has won
 * - `undefined` when no winner can be determined.
 */
function getGameWinner(game, rules) {
    rules_1.assertGameRules(rules);
    var scoreDiff = game.homeScore - game.awayScore;
    var hasMinimum = Math.max(game.homeScore, game.awayScore) >= rules.scoreMinimum;
    var hasDistance = Math.abs(scoreDiff) >= rules.scoreDistance;
    if (hasMinimum && hasDistance) {
        return scoreDiff > 0 ? "home" : "away";
    }
    return undefined;
}
exports.getGameWinner = getGameWinner;
